import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logoutRequest } from '../store/auth/actions';
import { LayoutDashboard, Users, History, LogOut, Shield } from 'lucide-react';
import './Sidebar.css';

const navItems = [
  { path: '/espace-admin', label: 'Tableau de bord', icon: LayoutDashboard, end: true },
  { path: '/espace-admin/utilisateurs', label: 'Utilisateurs', icon: Users, end: false },
  { path: '/espace-admin/historique', label: 'Historique', icon: History, end: false },
];

const AdminSidebar: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logoutRequest(navigate));
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-top">
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <path d="M12 2L2 7l10 5 10-5-10-5z" />
              <path d="M2 17l10 5 10-5" />
              <path d="M2 12l10 5 10-5" />
            </svg>
          </div>
          <div className="sidebar-logo-text">
            <span className="sidebar-logo-name">CNDJ</span>
            <span className="sidebar-logo-sub">Centre National de Doc...</span>
          </div>
        </div>

        <div className="sidebar-section-label">ESPACE ADMIN</div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}
            >
              <item.icon size={20} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </div>

      <div className="sidebar-bottom">
        <div className="sidebar-ia-card">
          <Shield size={20} className="sidebar-ia-icon" />
          <div>
            <strong>Administration</strong>
            <p>Gestion des utilisateurs et des rôles.</p>
          </div>
        </div>

        <button className="sidebar-logout" onClick={handleLogout}>
          <LogOut size={20} />
          <span>Déconnexion</span>
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
